import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Import tłumaczeń
import "../App.css";

const NavigationBar = () => {
  const [scrolling] = useState(false);
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true);
  const { i18n, t } = useTranslation(); // Inicjalizacja tłumaczeń
  const navbarRef = useRef<HTMLDivElement>(null);

  // Funkcja zmiany języka
  const toggleLanguage = () => {
    const newLanguage = i18n.language === "pl" ? "en" : "pl";
    i18n.changeLanguage(newLanguage);
  };

  // Funkcja zamykająca navbar po kliknięciu
  const handleLinkClick = () => {
    setIsNavbarCollapsed(true);
  };

  useEffect(() => {
    if (!isNavbarCollapsed) {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          navbarRef.current &&
          !navbarRef.current.contains(event.target as Node)
        ) {
          setIsNavbarCollapsed(true);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isNavbarCollapsed]);

  return (
    <>
      <Navbar
        ref={navbarRef}
        expand="lg"
        className={`ms-auto navbarblack py-3 shadow-sm navbar-scroll ${
          scrolling ? "navbar-scrolled" : ""
        }`}
        fixed="top"
        expanded={!isNavbarCollapsed}
      >
        <div className="opening-hours-bar row-fluid" style={{ width: "100vw" }}>
          <Container>
            <span>{t("openingHours")}</span>
          </Container>
        </div>
        <Container className="navbar-container"
                style={{width: "100vw", zIndex: 9999}}

        >
          <Navbar.Brand
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            as={Link}
            to="/"
            className="navbar-brand fs-3 fw-bold row-fluid toptop"
            style={{ cursor: "pointer" }} 
          >
            <img
              src={"/images/zadyma-logo.png"}
              height="76px"
              alt="Zadyma Niedzica"
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="navbar-nav"
            onClick={() => setIsNavbarCollapsed(!isNavbarCollapsed)}
          />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                as={Link}
                to="/"
                className="mx-2 nav-link toptop"
                onClick={handleLinkClick}
              >
                {t("home")}
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/menu"
                className="mx-2 nav-link toptop"
                onClick={handleLinkClick}
              >
                {t("menu")}
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/kontakt"
                className="mx-2 nav-link toptop"
                onClick={handleLinkClick}
              >
                {t("contact")}
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/rowery-elektryczne"
                className="mx-2 nav-link toptop"
                onClick={handleLinkClick}
              >
                {t("rental")}
              </Nav.Link>
            </Nav>
            {/* Przełącznik języka poza <Nav> */}
            <div className="language-switch ms-3">
              <div className="switch">
                <input
                  id="language-toggle"
                  className="check-toggle check-toggle-round-flat"
                  type="checkbox"
                  checked={i18n.language === "en"}
                  onChange={toggleLanguage}
                />
                <label htmlFor="language-toggle"></label>
                <span className="on">PL</span>
                <span className="off">EN</span>
              </div>
            </div>
          </Navbar.Collapse>
          
        </Container>
      </Navbar>
    </>
  );
};

export default NavigationBar;
